import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { ItemModel } from '../../models/item';

const getVisitTypeIdsSelector = createSelector(
    (state: State) => state.byVisitTypeId,
    (byVisitTypeId: Dictionary<ItemModel>) => memoize((
        isNewPatient: boolean
    ) => Object
        .keys(byVisitTypeId)
        .filter(x => isNewPatient === (byVisitTypeId[x]!.itemText || '').startsWith('new patient'))
        .map(x => +x)
    )
);

export const selectors = {
    getVisitStatus: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<ItemModel> => state.byVisitStatusId[id || ''],
    getVisitStatusIds: (
        state: State
    ): number[] => state.allVisitStatusIds,
    getVisitType: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<ItemModel> => state.byVisitTypeId[id || ''],
    getVisitTypeIds: (
        state: State,
        isNewPatient?: boolean
    ): number[] => typeof isNewPatient === 'undefined' ?
            state.allVisitTypeIds :
            getVisitTypeIdsSelector(state)(isNewPatient)
};
